import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { refreshContentFeed } from "reducers/actions/ContentFeedActions";
import ContentFeedConfirmModal from "./ContentFeedConfirmModal";

const buildTitle = contentFeedName => `Refresh "${contentFeedName}"?`;

export default function RefreshContentFeedModal({ onClose }) {
	const dispatch = useDispatch();

	function handleConfirm(contentFeedId) {
		return dispatch(refreshContentFeed(contentFeedId));
	}

	return (
		<ContentFeedConfirmModal
			onClose={onClose}
			confirmLabel="Refresh"
			confirmingLabel="Refreshing..."
			buildTitle={buildTitle}
			onConfirm={handleConfirm}
		/>
	);
}

RefreshContentFeedModal.displayName = "RefreshContentFeedModal";

RefreshContentFeedModal.propTypes = {
	onClose: PropTypes.func.isRequired,
};
